import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from './views/Home.vue'
import Projects from './views/Projects.vue'
import Projects_timeline from './views/Projects_timeline.vue'
import Project from './views/Project.vue'
import Clients from './views/Clients.vue'
import Client from './views/Client.vue'
import Economy from './views/Economy.vue'
import Users from './views/Users.vue'
import Kitchensink from './views/Kitchensink.vue'
import Timelogs from './views/Timelogs.vue'
import Mysettings from './views/Mysettings.vue'
import ThemeMachine from './views/ThemeMachine.vue'
import Reports from './views/Reports.vue'

import Specs from './views/Specs.vue'
import Spec from './views/Spec.vue'

import Report_invoicability from './views/Report_invoicability.vue'
import Report_missing_input from './views/Report_missing_input.vue'
import ReportMissingPayments from './views/ReportMissingPayments.vue'
import ReportClientEarning from './views/ReportClientEarning.vue'

var routes = [
  //{ path: '/', component: Home },
  { path: '/', component: Home },
  { path: '/projects', component: Projects },
  { path: '/clients', component: Clients },
  { path: '/client/:id', component: Client, name:'client' },
  { path: '/project/:id', component: Project, name:'project' },
  
  { path: '/specs', component: Specs },
  { path: '/spec/:id', component: Spec, props: { fdbs: this.fdbs } },

  { path: '/kitchensink', component: Kitchensink },
  { path: '/economy', component: Economy },
  { path: '/timeline', component: Projects_timeline },
  { path: '/users', component: Users },
  { path: '/my-settings', component: Mysettings },
  { path: '/tema-editor', component: ThemeMachine },

  { path: '/reports', component: Reports },
  	{ path: '/report-invoicability', component: Report_invoicability },
  	{ path: '/reports/missing-input', component: Report_missing_input },
  	{ path: '/reports/missing-payments', component: ReportMissingPayments },
  	{ path: '/reports/client-earning', component: ReportClientEarning },


  { path: '/timelogs', component: Timelogs },
  { path: '/timelogs/:user/:client/:project/:from_date/:to_date', component: Timelogs },

]

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'hash',
  base: '/',
})

export default router



// WEBPACK FOOTER //
// ./src/router.js